/** Word wheel play grid size (3–8 letter words fit in 8×8). Must match backend `WordWheelGridLayoutService.GRID_SIZE`. */
export const WORD_WHEEL_GRID_SIZE = 8;
